import { forwardRef } from 'react';
import { ICellEditorParams } from 'ag-grid-community';
import { DropDownMenuItem } from '../../../DropdownMenu';
import SharedAutoCompleteCellRender, { SharedAutoCompleteCellRenderRef } from '../../../SharedAutoComplete/SharedAutoCompleteCellRender';

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface AutoCompleteCellRenderProps<T=any> extends ICellEditorParams {
  options: DropDownMenuItem<T>[]
  onSelect: (row: T, selected: T) => void,
  onTextInput?: (row: T, value: string) => void
  onBlur?: () => void
  onBlurSetTextAsSelected?: boolean
}

export default forwardRef<SharedAutoCompleteCellRenderRef, AutoCompleteCellRenderProps>((props, ref) => (
  <div style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
    <SharedAutoCompleteCellRender
      ref={ref}
      value={props.value}
      stopEditing={props.stopEditing}
      options={props.options}
      onSelect={props.onSelect}
      onTextInput={props.onTextInput}
      onBlur={props.onBlur}
      onBlurSetTextAsSelected={props.onBlurSetTextAsSelected}
      rowIdentifier={props.data}
    />
  </div>
));
